import { customElement } from 'lit/decorators.js';
import { WEB_COMPONENT_HEALTH_DASHBOARD_POLICIES } from '../../../../webcomponents.constants';
import { GzHealthDashboardInsights } from './GzHealthDashboardInsights';
import { HealthDashboardPoliciesStrings, InsightsTemplatesStringKeys } from '../types';
import { translateFn } from '../../../../utils/translator.helper';
import { WidgetSectionItemSeverity } from '../../../../ui/gzWidgetSectionItem/types';

@customElement(WEB_COMPONENT_HEALTH_DASHBOARD_POLICIES)
export class GzHealthDashboardPoliciesWebComponent extends GzHealthDashboardInsights {
  protected widgetKey = InsightsTemplatesStringKeys.POLICY_COMPLIANCE;

  changedInfoBoxText = `
          ${translateFn('You have <b>updates</b> for this widget!')}
          <br />
          <br />
          ${translateFn(
            'To experience the latest design, close the current widget and select the new ones in the Settings panel. Apply your changes and save the view.'
          )}`;
  strings: HealthDashboardPoliciesStrings = {
    sections: [
      {
        key: InsightsTemplatesStringKeys.POLICY_COMPLIANCE,
        items: [
          {
            key: InsightsTemplatesStringKeys.COMPLIANT,
            name: translateFn('Compliant'),
            tooltipText: translateFn('Endpoints have a policy assigned, and the settings are applied.'),
            severity: WidgetSectionItemSeverity.SUCCESS,
          },
          {
            key: InsightsTemplatesStringKeys.NON_COMPLIANT,
            name: translateFn('Non-compliant'),
            tooltipText: translateFn(
              'Includes endpoints with assigned policies where settings are not applied, and endpoints with settings modified using Power User.'
            ),
            severity: WidgetSectionItemSeverity.ERROR,
          },
          {
            key: InsightsTemplatesStringKeys.OFFLINE_SINCE_LAST_CHANGE,
            name: translateFn('Offline since last policy changes'),
            tooltipText: translateFn(
              'Endpoints were offline after the policy was edited and have not received the new settings.'
            ),
            severity: WidgetSectionItemSeverity.WARNING,
          },
          {
            key: InsightsTemplatesStringKeys.EDITED_BY_POWER_USER,
            name: translateFn('Policy settings changed using Power User'),
            tooltipText: translateFn('The policy applied on endpoints was changed with Power User.'),
            severity: WidgetSectionItemSeverity.ERROR,
          },
          {
            key: InsightsTemplatesStringKeys.INHERITED,
            name: translateFn('Inherited policy'),
            tooltipText: translateFn('Endpoints have inherited policy settings.'),
            severity: WidgetSectionItemSeverity.SUCCESS,
          },
          {
            key: InsightsTemplatesStringKeys.DIRECTLY_APPLIED,
            name: translateFn('Directly applied policy'),
            tooltipText: translateFn('Endpoints have a policy that is directly assigned and applied.'),
            severity: WidgetSectionItemSeverity.SUCCESS,
          },
          {
            key: InsightsTemplatesStringKeys.ASSIGNED_WITH_POLICY_RULES,
            name: translateFn('Assigned policies using assignment rules'),
            tooltipText: translateFn('Endpoints have policies assigned based on assignment rules.'),
            severity: WidgetSectionItemSeverity.SUCCESS,
          },
        ],
      },
    ],
  };
}
